export const formatUsers = (users, groups) => {
  const newUsers = users.map((user) => {
    const { roles, ...userNoRoles } = user;
    // A role's groupID can point at a group that's since been deleted (orphaned
    // reference) - filter those out instead of crashing on a missing group.
    const userGroups = roles
      ?.map((role) => {
        const group = groups.find((g) => g.id === role.groupID);
        if (!group) return null;
        return {
          groupName: group.name,
          role: role.role,
        };
      })
      .filter(Boolean);
    return {
      ...userNoRoles,
      groups: userGroups,
    };
  });
  return newUsers;
};

export const formatGroups = (users, groups) => {
  const newGroups = groups.map((group) => {
    let numDashUsers = 0;
    users.forEach((user) => {
      if (user.type !== 'admin' && user.roles?.some((role) => role.groupID === group.id)) {
        numDashUsers++;
      }
    });
    return {
      ...group,
      numDashUsers,
    };
  });
  return newGroups;
};
